var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card-main",
    { staticClass: "content-center col-12", attrs: { id: "class-verified" } },
    [
      !_vm.studentEntry && !_vm.signupComplete
        ? _c(
            "div",
            [
              _c(
                "h4",
                {
                  staticClass: "underline",
                  staticStyle: { "margin-top": "30px" }
                },
                [
                  _vm._v(
                    "Class " + _vm._s(_vm.currentClass.CLASS_ID) + " Sign Up"
                  )
                ]
              ),
              _vm.getOpenSessions.length > 0
                ? _c("h6", [_vm._v("Please Select A Session:")])
                : _vm._e(),
              _c(
                "q-list",
                { staticClass: "q-mt-md" },
                [
                  _vm._l(_vm.getOpenSessions, function(session, i) {
                    return _c(
                      "q-item",
                      { key: i, attrs: { link: "", tag: "label" } },
                      [
                        _c(
                          "q-item-side",
                          [
                            _c("q-checkbox", {
                              attrs: {
                                disable: !_vm.mappedSessions[i].canRegister,
                                value: _vm.selectedSession.includes(
                                  session.SESSION_ID
                                ),
                                val: session.SESSION_ID
                              },
                              on: {
                                change: function(v) {
                                  return _vm.setSelectedSession({
                                    id: session.SESSION_ID,
                                    value: v,
                                    index: i
                                  })
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c("q-item-main", [
                          _vm._v(
                            "\n          " +
                              _vm._s("Session " + (i + 1)) +
                              "\n          "
                          ),
                          _vm.getInvalidSessionReason(i)
                            ? _c(
                                "p",
                                {
                                  staticClass: "text-red",
                                  staticStyle: {
                                    "font-weight": "500",
                                    "font-size": "13px"
                                  }
                                },
                                [
                                  _c("q-icon", { attrs: { name: "cancel" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getInvalidSessionReason(i)) +
                                      "             \n          "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _c("q-item-side", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatDate(session.SESSION_START_DATE)
                              ) +
                              "\n        "
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  _vm.getOpenSessions.length == 0
                    ? _c("q-item", [
                        _c("span", [
                          _c("h5", { staticClass: "text-red" }, [
                            _vm._v("No Open Sessions Available.")
                          ]),
                          _c("br"),
                          _vm._v(
                            " Please Ask your instructing agency to open registration for at least one session.\n        "
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "text-right",
                  staticStyle: { "margin-top": "20px" }
                },
                [
                  _c("q-btn", {
                    attrs: { label: "Back", outline: "", color: "secondary" },
                    on: {
                      click: function($event) {
                        _vm.clearCurrentClass()
                      }
                    }
                  }),
                  _vm._v(" \n      "),
                  _vm.hasRegisterableSessions
                    ? _c("q-btn", {
                        staticStyle: { "margin-right": "6px" },
                        attrs: { color: "primary", label: "Continue" },
                        on: {
                          click: function($event) {
                            _vm.advanceToStudentEntry()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.studentEntry && !_vm.signupComplete
        ? _c("div", [
            _c(
              "span",
              {
                staticClass: "text-meta text-grey-8 font-weight-medium",
                staticStyle: { "font-size": "12px" }
              },
              [
                _vm._v(
                  _vm._s(_vm.selectedSession.length) +
                    " SESSION" +
                    _vm._s(_vm.selectedSession.length > 1 ? "" : "S")
                )
              ]
            ),
            _c(
              "h4",
              {
                staticClass: "underline",
                staticStyle: { "margin-top": "0px" }
              },
              [_vm._v("Class " + _vm._s(_vm.currentClass.CLASS_ID))]
            ),
            _c("h5", { staticStyle: { margin: "0 13px 45px" } }, [
              _vm._v("Enter Your Details")
            ]),
            !_vm.driversLicenseUploaded
              ? _c(
                  "div",
                  [
                    _c("q-uploader", {
                      staticClass: "q-mb-md",
                      attrs: {
                        "float-label": "Drivers License Front*",
                        extensions: ".gif,.jpg,.jpeg,.png",
                        "auto-expand": "",
                        "hide-upload-button": "",
                        "hide-upload-progress": ""
                      }
                    }),
                    _c("q-uploader", {
                      attrs: {
                        "float-label": "Drivers License Back*",
                        "auto-expand": "",
                        "hide-upload-button": "",
                        "hide-upload-progress": ""
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.driversLicenseUploaded
              ? _c("div", {}, [
                  _c("div", { staticClass: "sl-row" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-3" },
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": "DL State",
                            value: _vm.student.dl_state,
                            options: _vm.stateOptions,
                            filter: "",
                            "autofocus-filter": ""
                          },
                          on: {
                            change: function(val) {
                              return _vm.updateStudentRecord({
                                field: "dl_state",
                                value: val
                              })
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-9" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.$v.student.dl.$error,
                              "error-label": _vm.driversLicenseError
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": "Drivers License #",
                                value: _vm.student.dl,
                                after: [{ icon: "flag", error: true }],
                                error: _vm.validateReq(_vm.$v.student.dl)
                              },
                              on: {
                                blur: _vm.$v.student.dl.$touch,
                                keyup: function($event) {
                                  $event.stopPropagation()
                                  _vm.updateStudentRecord({
                                    field: "dl",
                                    value: $event.target.value
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "First Name",
                            value: _vm.student.firstName,
                            error: _vm.validateReq(_vm.$v.student.firstName),
                            after: [{ icon: "flag", error: true }]
                          },
                          on: {
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "firstName",
                                value: $event.target.value
                              })
                            },
                            blur: _vm.$v.student.firstName.$touch
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "Middle Name",
                            value: _vm.student.middleName
                          },
                          on: {
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "middleName",
                                value: $event.target.value
                              })
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "Last Name",
                            value: _vm.student.lastName,
                            error: _vm.validateReq(_vm.$v.student.lastName),
                            after: [{ icon: "flag", error: true }]
                          },
                          on: {
                            blur: _vm.$v.student.lastName.$touch,
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "lastName",
                                value: $event.target.value
                              })
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-12" },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "places-autocomplete",
                              rawName: "v-places-autocomplete",
                              value: _vm.placeChange,
                              expression: "placeChange"
                            }
                          ],
                          ref: "googleAutocomplete",
                          attrs: {
                            "float-label": "Address",
                            value: _vm.student.address1,
                            error: _vm.validateReq(_vm.$v.student.address1),
                            after: [{ icon: "flag", error: true }],
                            autocomplete: "new-password"
                          },
                          on: {
                            blur: _vm.$v.student.address1.$touch,
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "address1",
                                value: $event.target.value
                              })
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-5" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "City",
                            value: _vm.student.city,
                            error: _vm.validateReq(_vm.$v.student.city),
                            after: [{ icon: "flag", error: true }],
                            autocomplete: "new-password"
                          },
                          on: {
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "city",
                                value: $event.target.value
                              })
                            },
                            blur: _vm.$v.student.city.$touch
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-3" },
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": "State",
                            value: _vm.student.state,
                            options: _vm.stateOptions,
                            autocomplete: "new-password",
                            filter: "",
                            "autofocus-filter": ""
                          },
                          on: {
                            change: function(val) {
                              return _vm.updateStudentRecord({
                                field: "state",
                                value: val
                              })
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "Zip",
                            value: _vm.student.zip,
                            autocomplete: "new-password",
                            error: _vm.validateReq(_vm.$v.student.zip),
                            after: [{ icon: "flag", error: true }]
                          },
                          on: {
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "zip",
                                value: $event.target.value
                              })
                            },
                            blur: _vm.$v.student.zip.$touch
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-3" },
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": "Gender",
                            value: _vm.student.gender,
                            options: _vm.genderOptions,
                            filter: "",
                            "autofocus-filter": ""
                          },
                          on: {
                            change: function(val) {
                              return _vm.updateStudentRecord({
                                field: "gender",
                                value: val
                              })
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-4" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.$v.student.dob.$error,
                              "error-label": "Invalid Date"
                            }
                          },
                          [
                            _c("sl-date-time", {
                              attrs: {
                                type: "date",
                                "float-label": "Date of Birth",
                                value: _vm.student.dob
                              },
                              on: {
                                blur: _vm.$v.student.dob.$touch,
                                keyup: function($event) {
                                  $event.stopPropagation()
                                  _vm.updateStudentRecord({
                                    field: "dob",
                                    value: $event.target.value
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "sl-col-5" },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "999-999-9999",
                              expression: "'999-999-9999'"
                            }
                          ],
                          attrs: {
                            "float-label": "Phone",
                            value: _vm.student.phone,
                            error: _vm.validateReq(_vm.$v.student.phone),
                            after: [{ icon: "flag", error: true }]
                          },
                          on: {
                            blur: _vm.$v.student.phone.$touch,
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "phone",
                                value: $event.target.value
                              })
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "sl-row" }, [
                    _c(
                      "div",
                      { staticClass: "sl-col-12" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": "Email Address",
                            value: _vm.student.email,
                            error: _vm.validateReq(_vm.$v.student.email),
                            after: [{ icon: "flag", error: true }]
                          },
                          on: {
                            keyup: function($event) {
                              $event.stopPropagation()
                              _vm.updateStudentRecord({
                                field: "email",
                                value: $event.target.value
                              })
                            },
                            blur: _vm.$v.student.email.$touch
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "text-right",
                staticStyle: { "margin-top": "20px" }
              },
              [
                _c("q-btn", {
                  attrs: { label: "Back", outline: "", color: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.studentEntryState(false)
                    }
                  }
                }),
                _vm._v(" \n      "),
                _c("q-btn", {
                  staticStyle: { "margin-right": "6px" },
                  attrs: { color: "primary", label: "Complete" },
                  on: {
                    click: function($event) {
                      _vm.completeRegistrationMethod()
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.signupComplete
        ? _c("div", [
            _c("div", { staticClass: "logo" }, [
              _c("span", [_vm._v("cascades")])
            ]),
            _c("div", { staticClass: "verified" }, [
              _c("h6", [_vm._v("Registration Complete!")]),
              _vm._v(
                "\n      Your session begins " +
                  _vm._s(
                    _vm.formatDate(_vm.selectedSessionObj().SESSION_START_DATE)
                  ) +
                  "\n    "
              )
            ]),
            _c(
              "div",
              {
                staticClass: "text-right",
                staticStyle: { "margin-top": "20px" }
              },
              [
                _c("q-btn", {
                  attrs: { label: "Done", outline: "", color: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.clearCurrentClass()
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }